import { __makeTemplateObject } from "tslib";
import { css, styled } from '../../../../foundation';
import { RcListItemSecondaryAction } from '../../../List/ListItemSecondaryAction';
import { RcGrow } from '../../../Transitions/Grow';
export var StyledListItemSecondaryAction = styled(RcListItemSecondaryAction)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  transform: none;\n  right: 0;\n  top: 0;\n"], ["\n  position: relative;\n  transform: none;\n  right: 0;\n  top: 0;\n"])));
export var StyledGrow = styled(RcGrow)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  transform-origin: center top;\n"], ["\n  transform-origin: center top;\n"])));
export var SubMenuStyle = function () {
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
};
var templateObject_1, templateObject_2, templateObject_3;
